import React, { useState } from 'react';
import { View } from 'react-native';
import { Page, BText, Drawer } from '../../../components';
import { Button } from '../../../components/Form';

export const DemoDrawer = () => {
  const [showDrawer_OK, setDrawer_OK] = useState<boolean>(false);
  const [showDrawer_OKCancel, setDrawer_OKCancel] = useState<boolean>(false);
  const [showDrawer_Nested, setDrawer_Nested] = useState<boolean>(false);
  const [showDrawer_Custom, setDrawer_Custom] = useState<boolean>(false);
  const [showDrawerNested, setDrawerNested] = useState<boolean>(false);

  return (
    <Page title={'Demo - Drawer'}>
      <Button onPress={() => setDrawer_OK(!showDrawer_OK)}>Show Drawer1 (Type=OK)</Button>
      <Button onPress={() => setDrawer_OKCancel(!showDrawer_OKCancel)}>Show Drawer2 (Type=OkCancel)</Button>
      <Button onPress={() => setDrawer_Nested(!showDrawer_Nested)}>Show Drawer3 (Nested)</Button>
      <Button onPress={() => setDrawer_Custom(!showDrawer_Custom)}>Show Drawer4 (Type=Custom)</Button>

      <Drawer id="drawer.OK" visible={showDrawer_OK} onClose={() => setDrawer_OK(false)} title={'This is drawer title'}>
        <BText>
          When writing a blog post, it's important to keep your target audience in mind. What are their interests and
          pain points? What questions do they have that your post can answer? By addressing these questions, you can
          create content that resonates with your readers and keeps them engaged.
        </BText>
      </Drawer>

      <Drawer
        id="drawer.OKCancel"
        visible={showDrawer_OKCancel}
        onClose={() => setDrawer_OKCancel(false)}
        type="onCancel"
        onOK={() => console.log('OK')}
        title={'This is drawer title - OK Cancel'}
      >
        <BText>
          When writing a blog post, it's important to keep your target audience in mind. What are their interests and
          pain points? What questions do they have that your post can answer? By addressing these questions, you can
          create content that resonates with your readers and keeps them engaged.
        </BText>
      </Drawer>

      <Drawer id="drawer.nested" visible={showDrawer_Nested} onClose={() => setDrawer_Nested(false)}>
        <BText>This is nested drawer, click the buttons below to show them</BText>
        <Button onPress={() => setDrawer_Custom(true)}>Sample 1</Button>
        <Button onPress={() => setDrawerNested(true)}>Sample 2</Button>
      </Drawer>

      <Drawer id="drawer.custom" type="custom" visible={showDrawer_Custom} onClose={() => setDrawer_Custom(false)}>
        <View style={{ width: 400, height: 300, margin: 'auto', borderRadius: 12, backgroundColor: '#fff' }}>
          <BText>This is custom drawer</BText>
        </View>
      </Drawer>

      <Drawer id="drawer-nested" visible={showDrawerNested} onClose={() => setDrawerNested(false)}>
        <BText>This is another drawer</BText>
      </Drawer>
    </Page>
  );
};
